import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';
import { IAPIFetchRequestOptions } from '@sondermind/utilities/models-http';

import {
  convertApiResponse,
  IAppointmentSlot,
  IProviderCalendarApiResponse
} from '../models/public-provider-calendar.interface';

@Injectable({
  providedIn: 'root'
})
export class ProviderCalendarHttpService {
  constructor(
    private http: HttpService,
    private configService: ConfigurationService
  ){}

  getAppointmentSlots$(
    providerPersonaId: number,
    providerTimeZone: string,
    opts: Partial<IAPIFetchRequestOptions> = {}
  ): Observable<IAppointmentSlot[]> {
    const url = this.getAppointmentSlotsUrl(providerPersonaId);
    const params = this.http.generateFetchParams(opts);

    return this.http.get<IProviderCalendarApiResponse>(url, params)
      .pipe(
        map((calendarResponse: IProviderCalendarApiResponse) => calendarResponse?.slots?.map(
          (slot) => convertApiResponse(slot, providerTimeZone)
        ) ?? []),
        this.http.handleHttpErrorStrict()
      );
  }

  private getAppointmentSlotsUrl(providerPersonaId: number): string {
    return `${this.configService.env.dataExchangeSvcBase}/public/v1/slots?persona_provider_id=${providerPersonaId}`;
  }
}
